<template>
  <div
    class="tw-w-full tw-flex tw-items-center tw-justify-start tw-flex-col tw-pb-16"
  >
    <TradePassportInsurance v-if="route?.params?.type === 'insurance'" />
    <TradePassportCertification v-if="route?.params?.type === 'certificate'" />
    <TradePassportSpecialism v-if="route?.params?.type === 'services'" />
    <TradePassportClientsBusiness
      v-if="route?.params?.type === 'clients-business'"
    />
    <TradePassportDbsOverview v-if="route?.params?.type === 'dbs'" />
    <TradePassportExperiencesOverview
      v-if="route?.params?.type === 'experience'"
    />
  </div>
</template>
<script setup>
import { useRoute } from "vue-router";

import TradePassportInsurance from "../components/TradePassportInsurance.vue";
import TradePassportCertification from "../components/TradePassportCertification.vue";
import TradePassportSpecialism from "../components/TradePassportSpecialism.vue";
import TradePassportClientsBusiness from "../components/TradePassportClientsBusiness.vue";
import TradePassportDbsOverview from "../components/TradePassportDbsOverview.vue";
import TradePassportExperiencesOverview from "../components/TradePassportExperiencesOverview.vue";

const route = useRoute();
</script>
<style lang="scss" scoped></style>
